// namespace GeniuzPOS.Purchase {

//     const addBranchAction: string = "add-edit-branch-action"

//     @Serenity.Decorators.registerEditor("PowerACC.Sales.OrderDetailGrid")
//     export class OrderDetailGrid<P = {}> extends  Serenity.EntityGrid<PoApprovalTranRow, P> {
//         protected getColumnsKey(): string { return PoApprovalTranColumns.columnsKey;; }
//         protected getIdProperty(): string { return PoApprovalTranRow.idProperty; }
//         protected getLocalTextPrefix(): string { return PoApprovalTranRow.localTextPrefix; }
//         protected getDialogType(): { new(...args: any[]): Widget<any> } { return PoApprovalTranDialog; }

//         protected getService(): string { return PoApprovalTranService.baseUrl; }

//         private editController: GridEditController

//         private _orderNo: string
//         private _callback: (packSize: string, prodName: string) => void | undefined

//         get SysDocNoo() {
//             return this._orderNo
//         }

//         set SysDocNoo(value: string) {
//             if (this._orderNo != value) {
//                 this._orderNo = value;
//                 this.setEquality(PoApprovalTranRow.Fields.SysDocNo, value)
//                 this.refresh();
//                 let btn = document.querySelector(".s-OrderDetailGrid .add-button")
//                 if (this._orderNo == "*") {
//                     btn.classList.add("disabled")
//                 } else {
//                     btn.classList.remove("disabled")
//                 }
//             }
//         }

//         public rowChanges(callback: (packSize: string, prodName: string) => void) {
//             this._callback = callback
//         }

//         constructor(prop: WidgetProps<P>) {
//             super(prop);

//             this.editController = new GridEditController({
//                 grid: this
//             });

//             this.slickGrid.onCellChange.subscribe((e, args) => {
//                 console.log(args);
//             })
//         }

//         protected getSlickOptions(): GridOptions {
//             const opt = super.getSlickOptions();

//             opt.editable = true;
//             opt.autoEdit = true;
//             opt.asyncEditorLoading = false;

//             return opt;
//         }

//         protected onClick(e: Event, row: number, cell: number) {
//             const item = this.itemAt(row);
//             if (this._callback) {
//                 this._callback(item.PackCode, item.ProdName);
//             }

//             const clickedElement = e.target as HTMLElement;
//             let action: string;
//             if (clickedElement.classList.contains("slick-cell")) {
//                 const el = clickedElement.querySelector(`.inline-action`) as HTMLElement;
//                 if (el) {
//                     action = el.getAttribute("data-action");
//                 }
//             } else if (clickedElement.classList.contains("inline-action")) {
//                 action = clickedElement.getAttribute("data-action");
//             } else if (clickedElement.classList.contains("fa") || clickedElement.classList.contains("bi")) {
//                 const el = clickedElement.closest(".inline-action") as HTMLElement;
//                 action = el.getAttribute("data-action")
//             }

//             if (action) {
//                 e.preventDefault()

//                 // if (action == addBranchAction) {
//                 //     const branchDialog = new BranchSelectorDialog({});
//                 //     branchDialog.dialogTitle = "Add/Edit Branch";
//                 //     branchDialog.OrderDetailId = item.Id;
//                 //     branchDialog.dialogOpen();
//                 // }
//             } else {
//                 e.stopPropagation();
//                 super.onClick(e, row, cell);
//             }
//         }

//         protected getInitialTitle(): string {
//             return null
//         }

//         protected usePager(): boolean {
//             return false;
//         }

//         protected getColumns(): Column<PoApprovalTranRow>[] {
//             const columns = super.getColumns();

//             let inlineAction = (actionKey: string, hint: string, iconClass: string): Column => ({
//                 name: 'Branch',
//                 width: 60,
//                 format: _ => `<a class="inline-action text-center" data-action="${actionKey}" title="${htmlEncode(hint)}"><i class="${htmlEncode(iconClass)}"></i></a>`,
//                 minWidth: 24,
//                 maxWidth: 60
//             })

//             const targetIndex = columns.findIndex(col => col.field == "TotalQty")

//             columns.splice(targetIndex, 0, inlineAction(addBranchAction, "Add/Edit Branch", faIcon("search", "green")))

//             return columns
//         }

//         // protected addButtonClick() {
//         //     this.openDialogsAsPanel = isSmallDevice()
//         //     super.addButtonClick();
//         // }

//         // protected editItem(entityOrId: any) {
//         //     this.openDialogsAsPanel = isSmallDevice()
//         //     super.editItem(entityOrId);
//         // }
//     }
// }
